import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Box,
  TextField,
  Radio,
  RadioGroup,
  InputLabel,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Select,
  MenuItem,
  IconButton,
  Paper,
  Tooltip,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormGroup,
  Tabs,
  Tab,
  Divider,
  Chip,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MoneyIcon from "@mui/icons-material/Money";
import AddIcon from "@mui/icons-material/Add";
import { ToastContainer, toast } from "react-toastify";
import AnrComments from "../../components/Anr/AnrComments";
import AnrLogs from "../../components/Anr/AnrLogs";

import {
  Save as SaveIcon,
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ArrowBack as ArrowBackIcon,
  Info as InfoIcon,
  Business as BusinessIcon,
  ViewKanban as ViewKanbanIcon,
} from "@mui/icons-material";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import { Link } from "react-router-dom";
import Barcode from "react-barcode";
import UploadExcel from "../../components/UploadExcel";
import { v4 as uuid } from "uuid";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FileUploadSection from "../Anr/FileUploadSection"; // Adjust path as needed
import { Search as SearchIcon } from "@mui/icons-material";
import { getToken, base_url } from "../../config/config";
// QR Code import
import { QRCodeCanvas } from "qrcode.react";
import KundenSelectionDialog from "../Anr/KundenSelectionDialog";

import { FilterPanel } from "../Anr/FilterPanel";
const API_BASE_URL = `${base_url}/v1`;

const StockAuftrageView = () => {
  // nevigation
  const navigate = useNavigate();

  // ---------------------
  // STATE VARIABLES
  // ---------------------
  const [apiData, setApiData] = useState([]);
  const [excelData, setExcelData] = useState(null);
  const [refreshId, setRefreshId] = useState(uuid());
  const [editData, setEditData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [statusData, setStatusData] = useState(null);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isParentOpen, setIsParentOpen] = useState(false);
  const [parentData, setParentData] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [isChecked, setIsChecked] = useState(false);
  const [isKundenDialogOpen, setIsKundenDialogOpen] = useState(false);
  // NEW: For flipping logic to show backside
  const [isFlipped, setIsFlipped] = useState(false);

  // Additional Status States
  const [isMaterialStatusOpen, setIsMaterialStatusOpen] = useState(false);
  const [materialStatusData, setMaterialStatusData] = useState(null);
  const [isNewMaterialStatusOpen, setIsNewMaterialStatusOpen] = useState(false);
  const [newMaterialStatusData, setNewMaterialStatusData] = useState(null);
  const [isWerkszeugnisseStatusOpen, setIsWerkszeugnisseStatusOpen] =
    useState(false);
  const [werkszeugnisseStatusData, setWerkszeugnisseStatusData] =
    useState(null);
  const [werkszeugnisRequired, setWerkszeugnisRequired] = useState(false);
  const [isTransportStatusOpen, setIsTransportStatusOpen] = useState(false);
  const [transportStatusData, setTransportStatusData] = useState(null);
  const [isMusterlieferungStatusOpen, setIsMusterlieferungStatusOpen] =
    useState(false);
  const [musterlieferungStatusData, setMusterlieferungStatusData] =
    useState(null);
  const [firms, setFirms] = useState([]);
  const [error, setError] = useState(null);
  const [kunden, setKunden] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [advancedFilters, setAdvancedFilters] = useState({ advanced: {} });
  const [filteredBySearch, setFilteredBySearch] = useState([]);

  // Pagination state
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const handleSetFilter = (filter) => {
    if (filter === undefined) filter = "";
    setGlobalFilter(filter);
    // Reset pagination when search filter changes
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const token = getToken();

  // Sort order
  const [anrSortOrder, setAnrSortOrder] = useState("asc");

  // Print Dialog states
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);
  const availablePrintFields = [
    { key: "ANR", label: "ANR" },
    { key: "Auftragsbezeichnung", label: "Auftragsbezeichnung" },
    { key: "Menge", label: "Menge" },
    { key: "invoiceNo", label: "Rechnung Nr." },
    { key: "percentDone", label: "Fortschritt (%)" },
    { key: "status", label: "Status" },
    { key: "deadline", label: "Auftragserteilungsdatum" },
    { key: "Lieferdatum", label: "Lieferdatum" },
    { key: "maxlohnfundHours", label: "MaxLohnFund (Stunden)" },
    { key: "maxlohnfundMinutes", label: "MaxLohnFund (Minuten)" },
    { key: "MengeCost", label: "Stückkosten" },
    { key: "shippingMethod", label: "Versandart" },
    { key: "packagingType", label: "Verpackungsart" },
    { key: "externalService", label: "Fremdleistung" },
    { key: "qualityNote", label: "Qualitätsnotiz" },
    { key: "completionDate", label: "Fertigstellungstermin" },
    { key: "Erläuterung", label: "Beschreibung" },
  ];
  const [selectedPrintFields, setSelectedPrintFields] = useState(
    availablePrintFields.map((f) => f.key),
  );
  const [isPrintOptionsDialogOpen, setIsPrintOptionsDialogOpen] =
    useState(false);
  const [selectedProjectForPrint, setSelectedProjectForPrint] = useState(null);

  // Missing Sequence Dialog
  const [missingSequenceDialogOpen, setMissingSequenceDialogOpen] =
    useState(false);
  const [missingSequence, setMissingSequence] = useState([]);

  // Extended Filtering
  const [selectedYear, setSelectedYear] = useState("all");
  const [sequenceFilter, setSequenceFilter] = useState("");

  // NEW: QR Code Dialog State
  const [qrOpen, setQrOpen] = useState(false);
  const [selectedANRForQR, setSelectedANRForQR] = useState(null);

  // Add state variables
  const [isMaxLohnFundDialogOpen, setIsMaxLohnFundDialogOpen] = useState(false);
  const [maxLohnFundData, setMaxLohnFundData] = useState(null);

  const handleCustomExport = () => {
    // 1) CSV Header row in the desired sequence
    const headers = [
      "ANR",
      "Kunden Nr",
      "Firma Name",
      "Bezeichnung",
      "Lieferdatum",
      "Auftragserteilungsdatum",
      "Fertigstellungstermin",
      "Auftrag Wert netto",
    ];

    // 2) Data rows
    const rows = filteredData.map((row) => {
      // --- Transform ANR the same way as before ---
      const parts = row.ANR.split("-");
      let transformedANR;
      if (parts.length >= 4) {
        const firstPartNoZeros = parseInt(parts[0], 10).toString();
        const yearPart = parts[3];
        transformedANR = `${firstPartNoZeros}-${yearPart}`;
      } else {
        transformedANR = row.ANR;
      }

      // --- Pull out each field ---
      const kundenNr = row.kundenID?.konto || "";
      const companyName = row.kundenID?.bezeichnung || "";
      const description = row.Auftragsbezeichnung || "";
      const lieferdatum = row.Lieferdatum || "";
      const auftragserteilungsdatum = row.deadline
        ? new Date(row.deadline).toLocaleDateString("de-DE")
        : "";
      const fertigstellungstermin = row.completionDate
        ? new Date(row.completionDate).toLocaleDateString("de-DE")
        : "";

      // Compute "Auftrag Wert netto" - multiply raw value by cost
      const value = row.MaxLohnaufwand || 0;
      const costPerUnit = parseFloat(row.MengeCost) || 0;
      const auftragWertNetto = (value * costPerUnit).toFixed(2);

      return [
        transformedANR,
        kundenNr,
        companyName,
        description,
        lieferdatum,
        auftragserteilungsdatum,
        fertigstellungstermin,
        auftragWertNetto,
      ];
    });

    // 3) Join into a CSV string
    const csvContent = [
      headers.join(";"),
      ...rows.map((r) => r.join(";")),
    ].join("\n");

    // 4) Trigger file download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "CustomExport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleOpenKundenDialog = () => {
    setIsKundenDialogOpen(true);
  };

  const handleCloseKundenDialog = () => {
    setIsKundenDialogOpen(false);
  };

  const handleSelectKunde = (kunde) => {
    setEditData((prev) => ({
      ...prev,
      kundenID: kunde,
    }));
    setSnackbar({
      open: true,
      message: `Kunde ${kunde.bezeichnung} ausgewählt`,
      severity: "success",
    });
  };

  // Handler to open the dialog
  const handleMaxLohnFundOpen = (project) => {
    setMaxLohnFundData({
      ...project,
      MaxLohnaufwand: project.MaxLohnaufwand || 0,
      maxlohnfundUnit: project.maxlohnfundUnit || "hours",
      MengeCost: project.MengeCost || 0,
    });
    setIsMaxLohnFundDialogOpen(true);
  };

  // Handler to close the dialog
  const handleMaxLohnFundClose = () => {
    setIsMaxLohnFundDialogOpen(false);
    setMaxLohnFundData(null);
  };

  // Handler to save the dialog data
  const handleMaxLohnFundSave = async () => {
    if (!maxLohnFundData) return;

    // Calculate the auftragswertNetto before saving - multiply raw value by cost
    let value = maxLohnFundData.MaxLohnaufwand || 0;
    const unit = maxLohnFundData.maxlohnfundUnit || "hours";
    if (unit === "minutes") {
      // Convert minutes to hours for pricing
      value = value / 60;
    }
    const costPerUnit = parseFloat(maxLohnFundData.MengeCost) || 0;
    const calculatedAuftragswertNetto = (value * costPerUnit).toFixed(2);

    const dataToSave = {
      ...maxLohnFundData,
      auftragswertNetto: calculatedAuftragswertNetto,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        dataToSave,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data.data;

      // Update local data
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );

      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );

      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }

      // Force a re-render of the table by triggering a small state change
      setTimeout(() => {
        setFilteredData((prevData) => [...prevData]);
      }, 100);

      handleMaxLohnFundClose();
      setSnackbar({
        open: true,
        message: "MaxLohnFund erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des MaxLohnFund",
        severity: "error",
      });
    }
  };

  // Helper function to calculate hours from the stored value
  const calculateHours = (value, unit) => {
    if (!value) return 0;

    if (unit === "hours") {
      return parseFloat(value);
    } else {
      // Convert minutes to hours
      return parseFloat(value) / 60;
    }
  };

  // Helper function to format the display of MaxLohnFund
  const formatMaxLohnFund = (value, unit) => {
    if (!value) return "0";

    const numValue = parseFloat(value);
    if (unit === "hours") {
      return `${numValue.toFixed(1)} Std`;
    } else {
      return `${numValue} Min`;
    }
  };

  // Add this helper function after the other utility functions (around line 200):
  const normalizeExternalService = (value) => {
    if (Array.isArray(value)) {
      return value;
    } else if (typeof value === "string" && value.trim()) {
      try {
        // Try to parse as JSON first (in case it's a stringified array)
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [value];
      } catch (e) {
        // If parsing fails, treat as single string value
        return [value];
      }
    }
    return [];
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);

        const page = pagination.pageIndex + 1; // API expects 1-based page numbers
        const limit = pagination.pageSize;

        let params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          search: globalFilter || "",
        });

        // Add existing filters
        if (selectedYear !== "all") {
          params.append("year", selectedYear);
        }
        if (sequenceFilter.trim() !== "") {
          params.append("sequence", sequenceFilter);
        }
        if (anrSortOrder) {
          params.append("sortOrder", anrSortOrder);
        }

        // Add advanced filters to backend
        if (advancedFilters && advancedFilters.advanced) {
          const {
            anr,
            description,
            kundenId,
            status,
            minQuantity,
            maxQuantity,
          } = advancedFilters.advanced;

          if (anr) {
            params.append("anr", anr);
          }
          if (description) {
            params.append("Auftragsbezeichnung", description);
          }
          if (kundenId && kundenId._id) {
            params.append("kundenID", kundenId._id);
          }
          if (status) {
            params.append("status", status);
          }
          if (minQuantity !== "" && minQuantity !== undefined) {
            params.append("minQuantityMenge", minQuantity);
          }
          if (maxQuantity !== "" && maxQuantity !== undefined) {
            params.append("maxQuantityMenge", maxQuantity);
          }
        }

        params.append("isStockAuftrag", "true");

        const response = await axios.get(
          `${API_BASE_URL}/getAllProjects?${params.toString()}`,
        );

        if (response.data.status === 1) {
          const { data, pagination } = response.data;
          const { totalPages, totalProjects } = pagination;

          // Normalize external service data for each project
          const normalizedData = data.map((project) => ({
            ...project,
            externalService: normalizeExternalService(project.externalService),
          }));

          setApiData((prevData) => {
            if (JSON.stringify(prevData) !== JSON.stringify(normalizedData)) {
              return normalizedData;
            }
            return prevData;
          });

          setFilteredData((prevData) => {
            if (JSON.stringify(prevData) !== JSON.stringify(normalizedData)) {
              return normalizedData;
            }
            return prevData;
          });

          // Only update counts if they changed
          setRowCount((prevCount) =>
            prevCount !== totalProjects ? totalProjects : prevCount,
          );
          setTotalPages((prevPages) => {
            const newTotalPages =
              totalPages || Math.ceil(totalProjects / limit);
            return prevPages !== newTotalPages ? newTotalPages : prevPages;
          });
        } else if (
          response.data.status === 0 &&
          response.data.message === "No projects found"
        ) {
          setApiData((prevData) => (prevData.length > 0 ? [] : prevData));
          setFilteredData((prevData) => (prevData.length > 0 ? [] : prevData));
          setRowCount((prevCount) => (prevCount !== 0 ? 0 : prevCount));
          setTotalPages((prevPages) => (prevPages !== 0 ? 0 : prevPages));

          setSnackbar((prevSnackbar) => {
            if (!prevSnackbar.open) {
              return {
                open: true,
                message: "Keine Projekte mit den angegebenen Filtern gefunden",
                severity: "info",
              };
            }
            return prevSnackbar;
          });
          return;
        }
      } catch (error) {
        console.error("Fehler beim Abrufen der Projekte:", error);

        // Handle 404 specifically for "No projects found"
        if (error.response && error.response.status === 404) {
          const errorData = error.response.data;
          if (errorData && errorData.message === "No projects found") {
            // Same logic as above for 404 case
            setApiData((prevData) => (prevData.length > 0 ? [] : prevData));
            setFilteredData((prevData) =>
              prevData.length > 0 ? [] : prevData,
            );
            setRowCount((prevCount) => (prevCount !== 0 ? 0 : prevCount));
            setTotalPages((prevPages) => (prevPages !== 0 ? 0 : prevPages));

            setSnackbar((prevSnackbar) => {
              if (!prevSnackbar.open) {
                return {
                  open: true,
                  message:
                    "Keine Projekte mit den angegebenen Filtern gefunden",
                  severity: "info",
                };
              }
              return prevSnackbar;
            });
            return; // Early return to prevent error snackbar
          }
        }

        setSnackbar((prevSnackbar) => ({
          open: true,
          message: "Fehler beim Abrufen der Projekte",
          severity: "error",
        }));
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [
    refreshId,
    globalFilter,
    pagination,
    selectedYear,
    sequenceFilter,
    anrSortOrder,
    advancedFilters,
  ]);

  useEffect(() => {
    const fetchKunden = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getKunden`);
        if (response.data.data) {
          setKunden(response.data.data);
        }
      } catch (error) {
        setError(
          "Kundendaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
        );
        console.error("Fehler beim Abrufen der Kunden:", error);
      }
    };
    fetchKunden();
  }, []);

  const handlePaginationChange = useCallback(
    (updater) => {
      const newPagination =
        typeof updater === "function" ? updater(pagination) : updater;
      console.log("Updated pagination:", newPagination);
      if (!newPagination) return;

      if (
        (newPagination.pageIndex !== pagination.pageIndex &&
          newPagination.pageIndex != undefined) ||
        (newPagination.pageSize !== pagination.pageSize &&
          newPagination.pageSize != undefined)
      ) {
        setPagination(newPagination);
      }
    },
    [pagination.pageIndex, pagination.pageSize],
  );

  const handleSortOrderChange = (event) => {
    setAnrSortOrder(event.target.value);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };
  const handleSequenceChange = (event) => {
    setSequenceFilter(event.target.value);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  // ---------------------
  // PROJECT HANDLERS
  // ---------------------
  const handleFilterChange = (filters) => {
    setAdvancedFilters(filters);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const handleResetFilters = () => {
    setAdvancedFilters({ advanced: {} });
    setGlobalFilter("");
    setSelectedYear("all");
    setSequenceFilter("");
    setAnrSortOrder("asc");
    // Reset pagination when filters are reset
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };
  // A small helper to let us update `editData` as the user changes inputs
  const handleChange = (field, value) => {
    setEditData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // When user clicks on a row
  const handleProjectClick = (project) => {
    setSelectedProject(project);
    // Make a copy for editing and normalize externalService
    const editableProject = {
      ...project,
      qualityNote: project.qualityNote || {
        datum: "",
        werkstucke: "",
        untershift: "",
      },
      externalService: normalizeExternalService(project.externalService),
    };
    setEditData(editableProject);
    setIsFlipped(true);
  };

  const handleBackToTable = () => {
    setIsFlipped(false);
    setSelectedProject(null);
    setIsEditMode(false);
    setEditData(null);
  };

  const navigateToNewReklamation = (ANR) => {
    console.log("Navigating to new Reklamation with ANR:", ANR);
    navigate("/reklamation/new", {
      state: { ANR },
    });
  };

  // We still keep this separate if we want a quick “Edit” button somewhere
  const handleEdit = () => {
    setEditData(selectedProject);
    setIsEditMode(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        "Sind Sie sicher, dass Sie dieses Projekt löschen möchten?",
      )
    )
      return;
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/deleteProject/${id}`,
      );
      if (response.data.success) {
        setApiData((prevData) =>
          prevData.filter((project) => project._id !== id),
        );
        setFilteredData((prevData) =>
          prevData.filter((project) => project._id !== id),
        );
        setSnackbar({
          open: true,
          message: "Projekt erfolgreich gelöscht",
          severity: "success",
        });
        if (selectedProject && selectedProject._id === id) {
          handleBackToTable();
        }
      }
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Löschen des Projekts",
        severity: "error",
      });
    }
  };

  const handleUpload = async () => {
    if (!excelData) {
      setSnackbar({
        open: true,
        message: "Bitte wählen Sie eine Excel-Datei zum Hochladen aus",
        severity: "warning",
      });
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/createProject`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
        excelData,
      );
      setSnackbar({
        open: true,
        message: "Erfolgreich hochgeladen",
        severity: "success",
      });
      setRefreshId(uuid());
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Hochladen der Daten",
        severity: "error",
      });
    }
  };

  // ---------------------  <-- CHANGED HERE
  // Save the changes (from backside form)
  // ---------------------
  // Update the handleSave function in AnrPage.jsx (around line 720):
  const handleSave = async () => {
    if (!editData) return;

    // Make a copy so we can transform it without mutating original
    const sendData = { ...editData };

    // Recalculate auftragswertNetto if MaxLohnaufwand or related fields have changed
    if (
      sendData.MaxLohnaufwand !== undefined &&
      sendData.MengeCost !== undefined
    ) {
      let value = sendData.MaxLohnaufwand || 0;
      const unit = sendData.maxlohnfundUnit || "hours";
      if (unit === "minutes") {
        // Convert minutes to hours for pricing
        value = value / 60;
      }
      const costPerUnit = parseFloat(sendData.MengeCost) || 0;
      sendData.auftragswertNetto = (value * costPerUnit).toFixed(2);
    }

    // ✅ Send externalService as array directly - let backend handle the formatting
    if (sendData.externalService) {
      const normalizedServices = normalizeExternalService(
        sendData.externalService,
      );
      // Remove the JSON.stringify - send as array directly
      sendData.externalService = normalizedServices;
    }

    // Ensure `deadline` is ISO string if present
    sendData.deadline =
      sendData.deadline && sendData.deadline !== "undefined"
        ? new Date(sendData.deadline).toISOString()
        : null;

    // If kundenID is an object, send only kundenID._id
    if (
      sendData.kundenID &&
      typeof sendData.kundenID === "object" &&
      sendData.kundenID._id
    ) {
      sendData.kundenID = sendData.kundenID._id;
    }
    // If lieferantID is an object, send only lieferantID._id
    if (
      sendData.lieferantID &&
      typeof sendData.lieferantID === "object" &&
      sendData.lieferantID._id
    ) {
      sendData.lieferantID = sendData.lieferantID._id;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        sendData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const updatedProject = response.data;
      // Update the local states
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setSelectedProject(updatedProject);
      setIsEditMode(false);

      // Force a re-render of the table by triggering a small state change
      setTimeout(() => {
        setFilteredData((prevData) => [...prevData]);
      }, 100);

      setSnackbar({
        open: true,
        message: "Projekt erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Projekts",
        severity: "error",
      });
    }
  };

  // add a comment from backside

  const handleAddComment = async (text) => {
    const trimmed = text.trim();
    if (!trimmed) return;

    try {
      const response = await fetch(`${base_url}/v1/commentProject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          projectId: selectedProject._id,
          comment: trimmed, // note: backend expects `comment`
        }),
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error("Add comment failed:", errText);
        toast.error("Fehler beim Hinzufügen des Kommentars", {
          autoClose: 3000,
        });
        return;
      }

      const updatedComments = await response.json();

      // replace local state so CommentsSection re-renders with the new comment
      setEditData(updatedComments);

      toast.success("Kommentar erfolgreich hinzugefügt", { autoClose: 3000 });
    } catch (err) {
      console.error("Error adding comment:", err);
      toast.error("Fehler beim Hinzufügen des Kommentars", { autoClose: 3000 });
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const response = await fetch(`${base_url}/v1/deleteComment`, {
        method: "POST", // or 'DELETE' if your server expects it
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          projectId: selectedProject._id,
          commentId,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Delete comment failed:", errorText);
        toast.error("Fehler beim Löschen des Kommentars", { autoClose: 3000 });
        return;
      }

      // assume the API returns the full updated project
      const updatedProject = await response.json();

      // merge only the comments back into your state
      setEditData((prev) => ({
        ...prev,
        comments: updatedProject.comments,
      }));

      toast.success("Kommentar erfolgreich gelöscht", { autoClose: 3000 });
    } catch (err) {
      console.error("Error deleting comment:", err);
      toast.error("Fehler beim Löschen des Kommentars", { autoClose: 3000 });
    }
  };

  const handleEditComment = async (commentId, newText) => {
    const trimmed = newText.trim();
    if (!trimmed) return;

    try {
      const response = await fetch(`${base_url}/v1/updateComment`, {
        method: "POST", // or 'PUT' if your API prefers
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          projectId: selectedProject._id,
          commentId,
          newComment: trimmed,
        }),
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error("Edit comment failed:", errText);
        toast.error("Fehler beim Bearbeiten des Kommentars", {
          autoClose: 3000,
        });
        return;
      }

      // API returns the full updated project
      const updatedProject = await response.json();

      // Merge only the comments into your existing project state
      setEditData((prev) => ({
        ...prev,
        comments: updatedProject.comments,
      }));

      toast.success("Kommentar erfolgreich aktualisiert", { autoClose: 3000 });
    } catch (err) {
      console.error("Error editing comment:", err);
      toast.error("Fehler beim Bearbeiten des Kommentars", { autoClose: 3000 });
    }
  };
  // --------------------- END CHANGES

  // ---------------------
  // DIALOG HANDLERS
  // ---------------------
  const handleMaterialStatusOpen = (project) => {
    setMaterialStatusData(project);
    setIsMaterialStatusOpen(true);
  };
  const handleMaterialStatusClose = () => {
    setIsMaterialStatusOpen(false);
    setMaterialStatusData(null);
  };
  const handleMaterialStatusSave = async () => {
    if (!materialStatusData) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        materialStatusData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleMaterialStatusClose();
      setSnackbar({
        open: true,
        message: "Meßwerkzeuge-Status erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Meßwerkzeuge-Status",
        severity: "error",
      });
    }
  };

  const handleNewMaterialStatusOpen = (project) => {
    setNewMaterialStatusData(project);
    setIsNewMaterialStatusOpen(true);
  };
  const handleNewMaterialStatusClose = () => {
    setIsNewMaterialStatusOpen(false);
    setNewMaterialStatusData(null);
  };
  const handleNewMaterialStatusSave = async () => {
    if (!newMaterialStatusData) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        newMaterialStatusData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleNewMaterialStatusClose();
      setSnackbar({
        open: true,
        message: "Materialstatus erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Materialstatus",
        severity: "error",
      });
    }
  };

  const handleWerkszeugnisseStatusOpen = (project) => {
    setWerkszeugnisseStatusData(project);
    setWerkszeugnisRequired(project.werkszeugnisRequired || false);
    setIsWerkszeugnisseStatusOpen(true);
  };
  const handleWerkszeugnisseStatusClose = () => {
    setIsWerkszeugnisseStatusOpen(false);
    setWerkszeugnisseStatusData(null);
  };
  const handleWerkszeugnisseStatusSave = async () => {
    if (!werkszeugnisseStatusData) return;
    const updatedData = { ...werkszeugnisseStatusData, werkszeugnisRequired };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleWerkszeugnisseStatusClose();
      setSnackbar({
        open: true,
        message: "Werkszeugnisse-Status erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Werkszeugnisse-Status",
        severity: "error",
      });
    }
  };

  const handleTransportStatusOpen = (project) => {
    setTransportStatusData(project);
    setIsTransportStatusOpen(true);
  };
  const handleTransportStatusClose = () => {
    setIsTransportStatusOpen(false);
    setTransportStatusData(null);
  };
  const handleTransportStatusSave = async () => {
    if (!transportStatusData) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        transportStatusData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleTransportStatusClose();
      setSnackbar({
        open: true,
        message: "Transportstatus erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Transportstatus",
        severity: "error",
      });
    }
  };

  const handleMusterlieferungStatusOpen = (project) => {
    setMusterlieferungStatusData(project);
    setIsMusterlieferungStatusOpen(true);
  };
  const handleMusterlieferungStatusClose = () => {
    setIsMusterlieferungStatusOpen(false);
    setMusterlieferungStatusData(null);
  };
  const handleMusterlieferungStatusSave = async () => {
    if (!musterlieferungStatusData) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        musterlieferungStatusData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleMusterlieferungStatusClose();
      setSnackbar({
        open: true,
        message: "Musterlieferung-Status erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Musterlieferung-Status",
        severity: "error",
      });
    }
  };

  const handleStatusOpen = (project) => {
    setStatusData(project);
    setIsStatusOpen(true);
  };
  const handleStatusClose = () => {
    setIsStatusOpen(false);
    setStatusData(null);
  };
  const handleStatusSave = async () => {
    if (!statusData) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        statusData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleStatusClose();
      setSnackbar({
        open: true,
        message: "Status erfolgreich aktualisiert",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Aktualisieren des Status",
        severity: "error",
      });
    }
  };

  const handleParentOpen = (project) => {
    setParentData(project);
    setIsParentOpen(true);
  };
  const handleParentClose = () => {
    setIsParentOpen(false);
    setParentData(null);
    setIsChecked(false);
  };
  const handleParentSave = async () => {
    if (!parentData?.ANR) {
      setSnackbar({
        open: true,
        message: "Ungültige Elterndaten",
        severity: "error",
      });
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/updateProject`,
        parentData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const updatedProject = response.data;
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setFilteredData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      if (selectedProject && selectedProject._id === updatedProject._id) {
        setSelectedProject(updatedProject);
      }
      handleParentClose();
      setSnackbar({
        open: true,
        message: "Eltern-ANR erfolgreich festgelegt",
        severity: "success",
      });
    } catch (error) {
      console.error("Fehler:", error);
      setSnackbar({
        open: true,
        message: "Fehler beim Festlegen des Eltern-ANR",
        severity: "error",
      });
    }
  };

  // ---------------------
  // QR Code Handlers
  // ---------------------
  const handleOpenQR = (anr) => {
    setSelectedANRForQR(anr);
    setQrOpen(true);
  };
  const handleCloseQR = () => {
    setSelectedANRForQR(null);
    setQrOpen(false);
  };

  //Dual Scroll bar
  const TableWithWorkingScrollbars = ({ children }) => {
    const [tableWidth, setTableWidth] = useState(0);
    const tableContainerRef = useRef(null);
    const topScrollRef = useRef(null);
    const bottomScrollRef = useRef(null);

    // Find the table container and set up observers after component mounts
    useEffect(() => {
      // Find MaterialReactTable's scrollable container
      const findTableContainer = () => {
        const table = document.querySelector(".MuiTable-root");
        if (table) {
          const scrollContainer = table.closest(".MuiTableContainer-root");
          if (scrollContainer) {
            return scrollContainer;
          }
        }
        return null;
      };

      // Function to update scrollbar widths based on table width
      const updateScrollbarWidths = () => {
        const container = findTableContainer();
        if (container) {
          tableContainerRef.current = container;
          setTableWidth(container.scrollWidth);

          // Add scroll event listener to the container
          container.addEventListener("scroll", handleTableScroll);

          // Hide the native scrollbar
          container.style.overflowX = "scroll";
          container.style.scrollbarWidth = "none"; // Firefox
          container.style.msOverflowStyle = "none"; // IE/Edge

          // For Chrome, Safari, and newer browsers
          if (!container.style.hasOwnProperty("scrollbarWidth")) {
            const style = document.createElement("style");
            const nodeId = `scrollbar-style-${Date.now()}`;
            container.id = nodeId;
            style.textContent = `
            #${nodeId}::-webkit-scrollbar {
              display: none;
              height: 0px !important;
              width: 0px !important;
            }
          `;
            document.head.appendChild(style);
          }
        }
      };

      // Initial setup
      updateScrollbarWidths();

      // Set up MutationObserver to detect changes in table size
      const observer = new MutationObserver(updateScrollbarWidths);
      const tableElement = document.querySelector(".MuiTable-root");

      if (tableElement) {
        observer.observe(tableElement, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      }

      // Clean up observer and event listeners
      return () => {
        observer.disconnect();
        if (tableContainerRef.current) {
          tableContainerRef.current.removeEventListener(
            "scroll",
            handleTableScroll,
          );
        }
      };
    }, []);

    // Handle scroll events from the table container
    const handleTableScroll = (e) => {
      if (topScrollRef.current) {
        topScrollRef.current.scrollLeft = e.target.scrollLeft;
      }
      if (bottomScrollRef.current) {
        bottomScrollRef.current.scrollLeft = e.target.scrollLeft;
      }
    };

    // Handle scroll events from the top scrollbar
    const handleTopScroll = (e) => {
      if (tableContainerRef.current) {
        tableContainerRef.current.scrollLeft = e.target.scrollLeft;
      }
      if (bottomScrollRef.current) {
        bottomScrollRef.current.scrollLeft = e.target.scrollLeft;
      }
    };

    // Handle scroll events from the bottom scrollbar
    const handleBottomScroll = (e) => {
      if (tableContainerRef.current) {
        tableContainerRef.current.scrollLeft = e.target.scrollLeft;
      }
      if (topScrollRef.current) {
        topScrollRef.current.scrollLeft = e.target.scrollLeft;
      }
    };

    // Common scrollbar styles
    const scrollbarStyles = {
      overflowX: "auto",
      overflowY: "hidden",
      height: "18px",
      "&::-webkit-scrollbar": {
        height: "14px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "rgba(0,0,0,0.05)",
        borderRadius: "7px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "primary.main",
        borderRadius: "7px",
        border: "2px solid transparent",
        backgroundClip: "content-box",
        "&:hover": {
          backgroundColor: "primary.dark",
        },
      },
      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
      border: "1px solid rgba(0,0,0,0.1)",
      borderRadius: "7px",
    };

    return (
      <Box sx={{ position: "relative" }}>
        {/* Top scrollbar */}
        <Box
          ref={topScrollRef}
          onScroll={handleTopScroll}
          sx={{
            ...scrollbarStyles,
            mb: 2,
          }}
        >
          {/* This creates the correct width for the scrollbar to match the table */}
          <Box sx={{ height: "1px", width: `${tableWidth}px` }} />
        </Box>

        {/* Hide the internal table scrollbar via CSS */}
        <Box
          sx={{
            // This will hide the scrollbar in the table
            ".MuiTableContainer-root": {
              msOverflowStyle: "none", // IE and Edge
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Safari and Chrome
                height: "0px !important",
                width: "0px !important",
              },
            },
          }}
        >
          {children}
        </Box>

        {/* Bottom scrollbar */}
        <Box
          ref={bottomScrollRef}
          onScroll={handleBottomScroll}
          sx={{
            ...scrollbarStyles,
            mt: 2,
          }}
        >
          {/* This creates the correct width for the scrollbar to match the table */}
          <Box sx={{ height: "1px", width: `${tableWidth}px` }} />
        </Box>
      </Box>
    );
  };

  // ---------------------
  // PRINT FUNCTIONS
  // ---------------------
  const printBarcodeFunc = (anr) => {
    const printWindow = window.open("", "PRINT", "height=400,width=600");
    printWindow.document.write("<html><head><title>Barcode drucken</title>");
    printWindow.document.write("</head><body>");
    const barcodeElement = document.getElementById("barcode-" + anr);
    if (barcodeElement) {
      printWindow.document.write(barcodeElement.innerHTML);
    }
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  const getDeadlineStatus = (deadlineStr) => {
    if (!deadlineStr) return { color: "inherit", status: "none" };
    const deadline = new Date(deadlineStr);
    const today = new Date();
    const diffTime = deadline.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays < 0) {
      return { color: "#f44336", status: "überfällig" };
    } else if (diffDays <= 7) {
      return { color: "orange", status: "warnung" };
    } else {
      return { color: "#4caf50", status: "gut" };
    }
  };

  const handleMissingSequence = (row) => {
    const parts = row.ANR.split("-");
    if (parts.length < 2) return;
    const suffix = parts.slice(1).join("-");
    const group = filteredData.filter(
      (p) => p.ANR.split("-").slice(1).join("-") === suffix,
    );
    const numbers = group.map((p) => parseInt(p.ANR.split("-")[0], 10));
    if (numbers.length < 2) {
      setSnackbar({
        open: true,
        message: "Nicht genügend Daten, um die Sequenz zu bestimmen",
        severity: "info",
      });
      return;
    }
    numbers.sort((a, b) => a - b);
    let missing = [];
    let wholeSequenceChanged = false;
    for (let i = 0; i < numbers.length - 1; i++) {
      const diff = numbers[i + 1] - numbers[i];
      if (diff === 2) {
        missing.push(numbers[i] + 1);
      } else if (diff > 2) {
        wholeSequenceChanged = true;
        break;
      }
    }
    if (wholeSequenceChanged) {
      setMissingSequence([]);
    } else {
      const formatted = missing.map((num) => num.toString().padStart(4, "0"));
      setMissingSequence(formatted);
    }
    setMissingSequenceDialogOpen(true);
  };

  const exportToPDF = () => {
    const doc = new jsPDF("landscape");
    doc.text("Projektdatenexport", 20, 10);
    const tableData = filteredData.map((row) => [
      row.ANR,
      row.Auftragsbezeichnung,
      row.Menge,
      row.invoiceNo,
      row.percentDone + "%",
      row.status,
      row.createdAt ? new Date(row.createdAt).toLocaleDateString() : "N/A",
    ]);
    doc.autoTable({
      head: [
        [
          "ANR",
          "Auftragsbezeichnung",
          "Menge",
          "Rechnung Nr.",
          "Prozent",
          "Status",
          "Datum",
        ],
      ],
      body: tableData,
      startY: 20,
    });
    doc.save("projekt_export.pdf");
  };

  const handleCustomPrint = () => {
    if (!selectedProjectForPrint) return;
    const printDate = new Date().toLocaleString();
    const barcodeElement = document.getElementById(
      `barcode-${selectedProjectForPrint.ANR}`,
    );
    const barcodeHTML = barcodeElement ? barcodeElement.innerHTML : "";
    const projectMeta = {
      printed: printDate,
      reference: selectedProjectForPrint.ANR,
      status: selectedProjectForPrint.status || "Nicht gesetzt",
    };

    const germanLabels = {
      printed: "Gedruckt",
      reference: "Referenz",
      status: "Status",
    };

    const metadataHTML = Object.entries(projectMeta)
      .map(
        ([key, value]) => `
        <div class="metadata-item">
          <span class="metadata-label">${
            germanLabels[key] || key.charAt(0).toUpperCase() + key.slice(1)
          }:</span>
          <span class="metadata-value">${value}</span>
        </div>
      `,
      )
      .join("");

    const tableRows = selectedPrintFields
      .map((key) => {
        const field = availablePrintFields.find((f) => f.key === key);
        let value = selectedProjectForPrint[key] || "";

        if (key === "deadline" && value) {
          if (value && value != "undefined") {
            const date = new Date(value);
            value = new Intl.DateTimeFormat("de-DE", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            }).format(date);
          } else {
            value = "N/A";
          }
        } else if (key === "externalService") {
          // Handle both array and string formats for external service
          const normalizedValue = normalizeExternalService(value);
          value =
            normalizedValue.length > 0
              ? normalizedValue.join(", ")
              : "Keine Fremdleistungen";
        } else if (typeof value === "number") {
          value = value.toLocaleString();
        } else if (Array.isArray(value)) {
          value = value.join(", ");
        } else if (key === "maxlohnfundHours") {
          // Calculate hours from MaxLohnaufwand and unit
          const maxLohnaufwand = selectedProjectForPrint.MaxLohnaufwand || 0;
          const unit = selectedProjectForPrint.maxlohnfundUnit || "hours";
          if (unit === "hours") {
            value = `${maxLohnaufwand} Std`;
          } else {
            // Convert minutes to hours
            const hours = (maxLohnaufwand / 60).toFixed(2);
            value = `${hours} Std`;
          }
        } else if (key === "maxlohnfundMinutes") {
          // Calculate minutes from MaxLohnaufwand and unit
          const maxLohnaufwand = selectedProjectForPrint.MaxLohnaufwand || 0;
          const unit = selectedProjectForPrint.maxlohnfundUnit || "hours";
          if (unit === "minutes") {
            value = `${maxLohnaufwand} Min`;
          } else {
            // Convert hours to minutes
            const minutes = (maxLohnaufwand * 60).toFixed(0);
            value = `${minutes} Min`;
          }
        } else if (key === "completionDate") {
          // Handle completion date formatting
          if (value && value !== "undefined") {
            const date = new Date(value);
            value = new Intl.DateTimeFormat("de-DE", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(date);
          } else {
            value = "Nicht gesetzt";
          }
        } else if (key === "qualityNote") {
          // Handle qualityNote object with datum, werkstucke, and untershift
          if (value && typeof value === "object") {
            const qualityNote = value;
            let qualityHtml =
              '<div style="font-size: 0.9em; line-height: 1.4;">';

            if (qualityNote.datum) {
              const qualityDate = new Date(qualityNote.datum);
              const formattedDate = new Intl.DateTimeFormat("de-DE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(qualityDate);
              qualityHtml += `<div><strong>Datum:</strong> ${formattedDate}</div>`;
            }

            if (qualityNote.werkstucke) {
              qualityHtml += `<div><strong>Anzahl Werkstücke:</strong> ${qualityNote.werkstucke}</div>`;
            }

            if (qualityNote.untershift) {
              qualityHtml += `<div><strong>Unterschrift:</strong> ✓ Vorhanden</div>`;
              // Add signature image if it's a URL
              if (
                typeof qualityNote.untershift === "string" &&
                (qualityNote.untershift.startsWith("http") ||
                  qualityNote.untershift.startsWith("data:"))
              ) {
                qualityHtml += `<div style="margin-top: 8px;">
                  <img src="${qualityNote.untershift}" 
                       alt="Unterschrift" 
                       style="max-width: 150px; max-height: 90px; border: 1px solid #ddd; border-radius: 4px;" />
                </div>`;
              }
            } else {
              qualityHtml += `<div><strong>Unterschrift:</strong> ✗ Nicht vorhanden</div>`;
            }

            qualityHtml += "</div>";
            value = qualityHtml;
          } else {
            value = "Keine Qualitätsdaten vorhanden";
          }
        }

        return `
          <tr>
            <th class="field-label">${field.label}</th>
            <td class="field-value">${value}</td>
          </tr>
        `;
      })
      .join("");

    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Projektdetails ${selectedProjectForPrint.ANR}</title>
          <style>
            @media print {
              @page {
                size: A4;
                margin: 15mm 20mm 20mm 20mm;
              }
              body {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              .no-print {
                display: none !important;
              }
            }
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
            }
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #333;
              background: #fff;
              position: relative;
              min-height: 100vh;
            }
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-45deg);
              font-size: 100px;
              opacity: 0.03;
              z-index: -1;
              pointer-events: none;
            }
            .container {
              max-width: 100%;
              margin: 0 auto;
              padding: 20px;
            }
            .header {
              padding: 20px 0;
              border-bottom: 2px solid #2c3e50;
              margin-bottom: 30px;
              text-align: center;
            }
            .header h1 {
              margin: 0;
              color: #2c3e50;
              font-size: 24px;
            }
            .metadata-section {
              background: #f8f9fa;
              padding: 15px;
              border-radius: 4px;
              margin-bottom: 30px;
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 15px;
            }
            .metadata-item {
              display: flex;
              flex-direction: column;
              gap: 5px;
            }
            .metadata-label {
              font-size: 0.8em;
              color: #666;
              text-transform: uppercase;
            }
            .metadata-value {
              font-weight: 500;
            }
            .barcode-section {
              text-align: center;
              margin: 20px 0;
              padding: 15px;
              background: #fff;
              border: 1px solid #eee;
              border-radius: 4px;
            }
            .data-table {
              width: 100%;
              border-collapse: collapse;
              margin: 20px 0;
              background: #fff;
              box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            }
            .data-table th,
            .data-table td {
              padding: 12px 15px;
              text-align: left;
              border: 1px solid #ddd;
            }
            .field-label {
              background: #f8f9fa;
              font-weight: 600;
              color: #2c3e50;
              width: 30%;
            }
            .field-value {
              color: #333;
            }
            .footer {
              position: fixed;
              bottom: 0;
              left: 0;
              right: 0;
              padding: 10px;
              background: #f8f9fa;
              border-top: 1px solid #ddd;
              font-size: 0.8em;
              color: #666;
              text-align: center;
            }
            .page-number:after {
              content: counter(page);
            }
            @media print {
              .page-break {
                page-break-before: always;
              }
            }
          </style>
        </head>
        <body>
          <div class="watermark">VERTRAULICH</div>
          <div class="container">
            <header class="header">
              <h1>Projektdetails</h1>
            </header>
            <div class="metadata-section">
              ${metadataHTML}
            </div>
            <div class="barcode-section">
              ${barcodeHTML}
            </div>
            <table class="data-table">
              ${tableRows}
            </table>
            <footer class="footer">
              <div>
                Gedruckt am ${printDate} | Seite <span class="page-number"></span> | Vertrauliches Dokument
              </div>
            </footer>
          </div>
          <script>
            window.onload = function() {
              const style = document.createElement('style');
              style.innerHTML = \`
                body { counter-reset: page; }
                .page-number:before { counter-increment: page; content: counter(page); }
              \`;
              document.head.appendChild(style);
            }
          </script>
        </body>
      </html>
    `;

    const printWindow = window.open("", "", "width=842,height=595");
    if (!printWindow) {
      console.error(
        "Fehler: Druckfenster konnte nicht geöffnet werden – Pop-ups könnten blockiert sein.",
      );
      return;
    }

    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.onafterprint = () => {
          printWindow.close();
          setIsPrintDialogOpen(false);
        };
      }, 1000);
    };
  };

  // ---------------------
  // COLUMNS DEFINITION
  // ---------------------
  // profile image column
  const profileimageColumn = (profileDoc, open, setOpen) => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {profileDoc ? (
            <img
              src={profileDoc.document.s3Url}
              alt={profileDoc.document.originalName || "Profile"}
              style={{
                width: 60,
                height: 60,
                objectFit: "cover",
                border: "1px solid #eee",
                background: "#fafafa",
                cursor: "pointer",
              }}
              onClick={() => setOpen(true)}
            />
          ) : (
            <Typography sx={{ color: "text.secondary", fontSize: "0.9rem" }}>
              Kein Profilbild
            </Typography>
          )}
        </Box>
        {/* Dialog for viewing the image */}
        {profileDoc && (
          <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm">
            <DialogContent
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={profileDoc.document.s3Url}
                alt={profileDoc.document.originalName || "Profile"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100vh",
                  borderRadius: "8px",
                  border: "2px solid #eee",
                  background: "#fafafa",
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpen(false)}>Schließen</Button>
            </DialogActions>
          </Dialog>
        )}
      </>
    );
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "ANR",
        header: "ANR",
        size: 140,
        Cell: ({ row }) => (
          <Typography
            sx={{
              cursor: "pointer",
              color: "text.primary",
              fontWeight: 600,
              "&:hover": {
                textDecoration: "underline",
                color: "primary.main",
              },
            }}
            onClick={() => handleProjectClick(row.original)}
          >
            {`${row.original.ANR} ${row.original.isReklamation ? "-R" : ""}`}
            {row.original.parentANR && ` (${row.original.parentANR})`}
          </Typography>
        ),
      },
      {
        accessorKey: "profile",
        header: "Profilbild",
        size: 140,
        Cell: ({ row }) => {
          // Find the profile image document
          const docs = row.original.projectDocument || [];
          const profileDoc = docs.find(
            (doc) =>
              doc.categoryId &&
              doc.categoryId.name &&
              doc.categoryId.name.toLowerCase() === "profile image" &&
              doc.document &&
              doc.document.s3Url,
          );
          // Local state for dialog open/close
          const [open, setOpen] = useState(false);

          return profileimageColumn(profileDoc, open, setOpen);
        },
      },
      {
        header: "Sequenz-Prüfung",
        id: "seqCheck",
        size: 50,
        Cell: ({ row }) => (
          <Tooltip title="Fehlende Sequenz prüfen" arrow>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleMissingSequence(row.original);
              }}
            >
              <InfoIcon color="primary" />
            </IconButton>
          </Tooltip>
        ),
      },
      {
        accessorKey: "MeßwerkzeugeStatus",
        header: (
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            Meßwerkzeuge
          </Box>
        ),
        size: 10,
        Cell: ({ row }) => {
          const getStatusColor = (status) => {
            switch (status) {
              case "Meßwerkzeuge im Hause vorhanden":
                return "#4caf50";
              case "Meßwerkzeuge müssen besorgt werden":
                return "#f44336";
              case "Messwerkzeuge eingegangen":
                return "#ffeb3b";
              default:
                return "gray";
            }
          };
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip
                title={row.original.MeßwerkzeugeStatus || "Nicht gesetzt"}
                arrow
                placement="top"
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMaterialStatusOpen(row.original);
                  }}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: getStatusColor(
                      row.original.MeßwerkzeugeStatus,
                    ),
                    cursor: "pointer",
                    border: "1px solid rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0,0,0,0.1)",
                      transform: "scale(1.1)",
                      transition: "all 0.2s ease",
                    },
                  }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "MaterialStatus",
        header: (
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            Materialstatus
          </Box>
        ),
        size: 10,
        Cell: ({ row }) => {
          const getMaterialStatusColor = (status) => {
            switch (status) {
              case "Materialeingang erfolgt":
                return "#4caf50";
              case "Material bestellt":
                return "orange";
              case "Materialteillieferung erfolgt":
                return "#ffeb3b";
              case "Material angefragt":
                return "gray";
              default:
                return "gray";
            }
          };
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip
                title={row.original.MaterialStatus || "Nicht gesetzt"}
                arrow
                placement="top"
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNewMaterialStatusOpen(row.original);
                  }}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: getMaterialStatusColor(
                      row.original.MaterialStatus,
                    ),
                    cursor: "pointer",
                    border: "1px solid rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0,0,0,0.1)",
                      transform: "scale(1.1)",
                      transition: "all 0.2s ease",
                    },
                  }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "WerkszeugnisseStatus",
        header: (
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            Werkszeugnisse
          </Box>
        ),
        size: 10,
        Cell: ({ row }) => {
          const getWerkszeugnisseColor = (status) => {
            switch (status) {
              case "Werkszeugnis eingegangen":
                return "#4caf50";
              case "Teil":
                return "#ffeb3b";
              case "Nicht eingegangen":
                return "#f44336";
              default:
                return "gray";
            }
          };
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip
                title={row.original.WerkszeugnisseStatus || "Nicht gesetzt"}
                arrow
                placement="top"
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    handleWerkszeugnisseStatusOpen(row.original);
                  }}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: getWerkszeugnisseColor(
                      row.original.WerkszeugnisseStatus,
                    ),
                    cursor: "pointer",
                    border: "1px solid rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0,0,0,0.1)",
                      transform: "scale(1.1)",
                      transition: "all 0.2s ease",
                    },
                  }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "TransportStatus",
        header: (
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            Transport
          </Box>
        ),
        size: 10,
        Cell: ({ row }) => {
          const getTransportColor = (status) => {
            switch (status) {
              case "Organisiert":
                return "#4caf50";
              case "Nicht organisiert":
                return "#f44336";
              default:
                return "gray";
            }
          };
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip
                title={row.original.TransportStatus || "Nicht gesetzt"}
                arrow
                placement="top"
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTransportStatusOpen(row.original);
                  }}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: getTransportColor(
                      row.original.TransportStatus,
                    ),
                    cursor: "pointer",
                    border: "1px solid rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0,0,0,0.1)",
                      transform: "scale(1.1)",
                      transition: "all 0.2s ease",
                    },
                  }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "MusterlieferungStatus",
        header: (
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            Musterlieferung
          </Box>
        ),
        size: 10,
        Cell: ({ row }) => {
          const getMusterlieferungColor = (status) => {
            switch (status) {
              case "Eingang erfolgt":
                return "#4caf50";
              case "Kein Eingang":
                return "#f44336";
              default:
                return "gray";
            }
          };
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip
                title={row.original.MusterlieferungStatus || "Nicht gesetzt"}
                arrow
                placement="top"
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMusterlieferungStatusOpen(row.original);
                  }}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: getMusterlieferungColor(
                      row.original.MusterlieferungStatus,
                    ),
                    cursor: "pointer",
                    border: "1px solid rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0,0,0,0.1)",
                      transform: "scale(1.1)",
                      transition: "all 0.2s ease",
                    },
                  }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "Auftragsbezeichnung",
        header: "Auftragsbezeichnung",
      },
      {
        accessorKey: "Menge",
        header: "Menge Kundenauftrag",
        size: 80,
      },
      {
        accessorKey: "kundenID",
        header: "Kunden",
        size: 80,
        Cell: ({ row }) => {
          const [isDialogOpen, setIsDialogOpen] = useState(false);
          const kunde = row.original.kundenID;
          const handleOpen = (e) => {
            e.stopPropagation();
            setIsDialogOpen(true);
          };
          const handleClose = () => {
            setIsDialogOpen(false);
          };
          return (
            <>
              <Typography
                onClick={handleOpen}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    color: "primary.main",
                    textDecoration: "underline",
                  },
                }}
              >
                {kunde
                  ? `${kunde.konto} - ${kunde.bezeichnung}`
                  : "Nicht gesetzt"}
              </Typography>
              <Dialog
                open={isDialogOpen}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle
                  sx={{
                    pb: 1,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  Kundendetails
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                  {kunde ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary">
                          Kontonummer
                        </Typography>
                        <Typography variant="body1">{kunde.konto}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary">
                          Kundenname
                        </Typography>
                        <Typography variant="body1">
                          {kunde.bezeichnung}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary">
                          Kurzbezeichnung
                        </Typography>
                        <Typography variant="body1">
                          {kunde.kurzbezeichnung || "Nicht angegeben"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary">
                          USt-IdNr.
                        </Typography>
                        <Typography variant="body1">
                          {kunde.ustIdNummer || "Nicht angegeben"}
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <Typography color="text.secondary">
                      Keine Kundendetails vorhanden
                    </Typography>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} color="primary">
                    Schließen
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          );
        },
      },
      {
        accessorKey: "deadline",
        header: "Auftragserteilungsdatum",
        size: 80,
        Cell: ({ row }) => {
          const deadlineStr = row.original.deadline;
          const { color } = getDeadlineStatus(deadlineStr);
          return deadlineStr ? (
            <Typography
              sx={{
                color: color,
                fontWeight:
                  color === "orange" || color === "#f44336" ? 700 : 400,
              }}
            >
              {new Date(deadlineStr).toLocaleDateString()}
            </Typography>
          ) : (
            <Typography color="text.secondary">Nicht gesetzt</Typography>
          );
        },
      },
      {
        accessorKey: "completionDate",
        header: "Fertigstellungstermin",
        size: 80,
        Cell: ({ row }) => {
          const completionDateStr = row.original.completionDate;
          return completionDateStr ? (
            <Typography>
              {new Date(completionDateStr).toLocaleDateString()}
            </Typography>
          ) : (
            <Typography color="text.secondary">Nicht gesetzt</Typography>
          );
        },
      },
      {
        accessorKey: "kostenstelle",
        header: "Kostenstelle",
        size: 80,
        Cell: ({ row }) => (
          <Typography>
            {row.original.kostenstelle || "Nicht zugewiesen"}
          </Typography>
        ),
      },
      {
        accessorKey: "Lieferdatum",
        header: "Lieferdatum",
        size: 80,
        Cell: ({ row }) => (
          <Typography>
            {row.original.Lieferdatum || "Nicht zugewiesen"}
          </Typography>
        ),
      },

      {
        accessorKey: "invoiceNo",
        header: "Rechnung Nr.",
      },
      {
        accessorKey: "MaxLohnaufwand",
        header: "MaxLohnFund",
        size: 80,
        Cell: ({ row }) => {
          const value = row.original.MaxLohnaufwand || 0;
          const unit = row.original.maxlohnfundUnit || "hours";
          return <Typography>{formatMaxLohnFund(value, unit)}</Typography>;
        },
      },
      {
        accessorKey: "MengeCost",
        header: "Stückkosten",
        size: 80,
        Cell: ({ row }) => {
          const cost = parseFloat(row.original.MengeCost) || 0;
          return (
            <Typography>{cost ? `€${cost.toFixed(2)}` : "€0.00"}</Typography>
          );
        },
      },
      {
        accessorKey: "estimatedPrice",
        header: "Geschätzter Preis",
        size: 80,
        Cell: ({ row }) => {
          let value = row.original.MaxLohnaufwand || 0;
          const unit = row.original.maxlohnfundUnit || "hours";
          const cost = parseFloat(row.original.MengeCost) || 0;

          // Calculate estimated price directly with the unit value
          // If unit is minutes, multiply minutes by cost
          // If unit is hours, multiply hours by cost
          if (unit === "minutes") {
            // Convert minutes to hours for pricing
            value = value / 60;
          }
          const estimatedPrice = value * cost;

          return (
            <Typography fontWeight={estimatedPrice > 0 ? "bold" : "normal"}>
              {`€${estimatedPrice.toFixed(2)}`}
            </Typography>
          );
        },
      },
      {
        accessorKey: "auftragswertNetto",
        header: "Auftragswert (netto)",
        size: 80,
        Cell: ({ row }) => {
          const value = row.original.auftragswertNetto || 0;
          return <Typography>{value}</Typography>;
        },
      },

      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ row }) => (
          <Button
            variant="contained"
            size="small"
            onClick={() => handleStatusOpen(row.original)}
            sx={{
              backgroundColor:
                row.original.status === "fertig"
                  ? "#4caf50"
                  : row.original.status === "anghalten"
                    ? "#f44336"
                    : "#ffeb3b",
              color: row.original.status === "ausstehend" ? "black" : "white",
            }}
          >
            {row.original.status || "Status setzen"}
          </Button>
        ),
      },

      {
        accessorKey: "actions",
        header: "Aktionen",
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title="Löschen">
              <IconButton
                onClick={() => handleDelete(row.original._id)}
                color="error"
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Link
              to={`/kanbanANR/${row.original._id}`}
              state={{ projectDetails: row.original }}
            >
              <Button
                variant="contained"
                size="small"
                startIcon={<ViewKanbanIcon />}
                sx={{
                  bgcolor: "#4361ee",
                  "&:hover": { bgcolor: "#3651d1" },
                }}
              >
                Kanban Board
              </Button>
            </Link>
            <Link to={`/DocumentLabeler/${row.original.ANR}`}>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  borderColor: "divider",
                  color: "text.primary",
                  "&:hover": {
                    borderColor: "primary.main",
                    color: "primary.main",
                  },
                }}
              >
                Dokumente hochladen
              </Button>
            </Link>
            <Link to={`/FileManager/${row.original.ANR}`}>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  borderColor: "divider",
                  color: "text.primary",
                  "&:hover": {
                    borderColor: "primary.main",
                    color: "primary.main",
                  },
                }}
              >
                Dokumente anzeigen
              </Button>
            </Link>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleParentOpen(row.original)}
              sx={{
                borderColor: "divider",
                color: "text.primary",
                "&:hover": {
                  borderColor: "primary.main",
                  color: "primary.main",
                },
              }}
            >
              Eltern festlegen
            </Button>
            {/* Print Options Button */}
            <Button
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProjectForPrint(row.original);
                setIsPrintDialogOpen(true);
              }}
              sx={{
                borderColor: "divider",
                color: "text.primary",
                "&:hover": {
                  borderColor: "primary.main",
                  color: "primary.main",
                },
              }}
            >
              Drucken
            </Button>
            {/* NEW: QR Upload Button */}
            <Button
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenQR(row.original.ANR);
              }}
              sx={{
                borderColor: "divider",
                color: "text.primary",
                "&:hover": {
                  borderColor: "primary.main",
                  color: "primary.main",
                },
              }}
            >
              QR Upload
            </Button>
            <Tooltip title="MaxLohnFund bearbeiten">
              <Button
                variant="outlined"
                size="small"
                startIcon={<MoneyIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMaxLohnFundOpen(row.original);
                }}
                sx={{
                  borderColor: "divider",
                  color: "text.primary",
                  "&:hover": {
                    borderColor: "primary.main",
                    color: "primary.main",
                  },
                }}
              >
                MaxLohnFund
              </Button>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [filteredData, availablePrintFields, selectedPrintFields],
  );

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <Box sx={{ position: "relative", perspective: "1000px" }}>
        <div
          style={{
            transformStyle: "preserve-3d",
            transition: "transform 0.6s",
            transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* FRONT SIDE: The table + filters */}
          <Box
            sx={{
              position: isFlipped ? "absolute" : "relative",
              width: "100%",
              backfaceVisibility: "hidden",
            }}
          >
            {/* Action bar */}
            <>
              <FilterPanel
                apiData={apiData}
                kunden={kunden}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                onFilterChange={handleFilterChange}
                onResetFilters={handleResetFilters}
              />

              <Paper sx={{ p: 2, mb: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpload}
                      fullWidth
                    >
                      Speichern
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <UploadExcel setExcelData={setExcelData} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth>
                      <InputLabel>Nach Jahr filtern</InputLabel>
                      <Select
                        value={selectedYear}
                        onChange={handleYearChange}
                        label="Nach Jahr filtern"
                      >
                        <MenuItem value="all">Alle Jahre</MenuItem>
                        <MenuItem value="23">2023</MenuItem>
                        <MenuItem value="24">2024</MenuItem>
                        <MenuItem value="25">2025</MenuItem>
                        <MenuItem value="26">2026</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth>
                      <InputLabel>Sortierreihenfolge</InputLabel>
                      <Select
                        value={anrSortOrder}
                        onChange={handleSortOrderChange}
                        label="Sortierreihenfolge"
                      >
                        <MenuItem value="asc">Aufsteigend</MenuItem>
                        <MenuItem value="desc">Absteigend</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={exportToPDF}
                  >
                    Als PDF exportieren
                  </Button>

                  <Button variant="contained" onClick={handleCustomExport}>
                    Custom Export
                  </Button>
                </Box>
              </Paper>
            </>
            {/* Table */}
            <Paper sx={{ p: 2 }}>
              <TableWithWorkingScrollbars>
                <MaterialReactTable
                  columns={columns}
                  data={filteredData}
                  enablePagination={true}
                  enableBottomToolbar={true}
                  enableTopToolbar={true}
                  enableGlobalFilter={true}
                  onGlobalFilterChange={handleSetFilter}
                  manualPagination={true} // Enable server-side pagination
                  rowCount={rowCount}
                  pageCount={totalPages} // Provide total pages from API
                  onPaginationChange={handlePaginationChange}
                  state={{
                    globalFilter,
                    isLoading: loading,
                    pagination,
                  }}
                  initialState={{
                    pagination: {
                      pageIndex: 0,
                      pageSize: 25,
                    },
                  }}
                  enableColumnFilters={false}
                  enableColumnActions={false}
                  muiPaginationProps={{
                    showRowsPerPage: true,
                    showFirstLastPageButtons: true,
                    rowsPerPageOptions: [10, 25, 50, 100],
                    labelDisplayedRows: ({ from, to, count }) =>
                      `${from}-${to} von ${
                        count !== -1 ? count : `mehr als ${to}`
                      } (Seite ${pagination.pageIndex + 1} von ${totalPages})`,
                    labelRowsPerPage: "Zeilen pro Seite:",
                  }}
                  renderEmptyRowsFallback={() => (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "200px",
                        textAlign: "center",
                        p: 3,
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        gutterBottom
                      >
                        Keine Projekte gefunden
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Keine Projekte mit den angegebenen Filtern gefunden.
                        Versuchen Sie, die Filter zu ändern oder zurückzusetzen.
                      </Typography>
                    </Box>
                  )}
                />
              </TableWithWorkingScrollbars>
            </Paper>
          </Box>

          {/* BACK SIDE: Detailed edit form */}
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              backfaceVisibility: "hidden",
              transform: "rotateY(180deg)",
              p: 3,
            }}
          >
            {selectedProject ? (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Bearbeite ANR: {selectedProject.ANR}
                </Typography>

                <Box sx={{ mb: 3 }}>
                  <Link
                    to={`/kanbanANR/${selectedProject._id}`}
                    state={{ projectDetails: selectedProject }}
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<KundenSelectionDialog />}
                      sx={{
                        bgcolor: "#4361ee",
                        "&:hover": { bgcolor: "#3651d1" },
                        mb: 2,
                      }}
                    >
                      Aufgabenverwaltung (Kanban Board)
                    </Button>
                  </Link>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "flex-start",
                    flexDirection: { xs: "column", md: "row" },
                    width: "100%",
                  }}
                >
                  <Box sx={{ flex: 2, minWidth: 0 }}>
                    <Paper
                      elevation={3}
                      component="form"
                      sx={{
                        py: 4,
                        px: 3,
                        borderRadius: 3,
                        mb: 4,
                        borderRadius: 3,
                        mb: 4,
                        bgcolor: "background.paper",
                        boxShadow: "0 8px 32px rgba(67,97,238,0.10)",
                        position: "relative",
                        overflow: "hidden",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          height: "6px",
                          background:
                            "linear-gradient(to right, #4361ee, #3a0ca3)",
                        }}
                      />
                      <Typography variant="h6" fontWeight={700} sx={{ mb: 3 }}>
                        Projektdetails bearbeiten
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <TextField
                            label="ANR"
                            value={editData.ANR || ""}
                            onChange={(e) =>
                              handleChange("ANR", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Auftragsbezeichnung"
                            value={editData.Auftragsbezeichnung || ""}
                            onChange={(e) =>
                              handleChange(
                                "Auftragsbezeichnung",
                                e.target.value,
                              )
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Menge"
                            value={editData.Menge || ""}
                            onChange={(e) =>
                              handleChange("Menge", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Rechnung Nr."
                            value={editData.invoiceNo || ""}
                            onChange={(e) =>
                              handleChange("invoiceNo", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Fortschritt (%)"
                            value={editData.percentDone || ""}
                            onChange={(e) =>
                              handleChange("percentDone", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            type="date"
                            label="Auftragserteilungsdatum"
                            InputLabelProps={{ shrink: true }}
                            value={
                              editData.deadline &&
                              editData.deadline !== "undefined"
                                ? new Date(editData.deadline)
                                    .toISOString()
                                    .substr(0, 10)
                                : ""
                            }
                            onChange={(e) =>
                              handleChange("deadline", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Erläuterung"
                            value={editData.Erläuterung || ""}
                            onChange={(e) =>
                              handleChange("Erläuterung", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            multiline
                            minRows={3}
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Eltern-ANR"
                            value={editData.parentANR || ""}
                            onChange={(e) =>
                              handleChange("parentANR", e.target.value)
                            }
                            fullWidth
                            variant="outlined"
                            sx={{ borderRadius: 2 }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          {/* Customer Selection Field */}
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" gutterBottom>
                              Kunde
                            </Typography>
                            <Box
                              onClick={handleOpenKundenDialog}
                              sx={{
                                p: 2,
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 2,
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                bgcolor: "background.paper",
                                "&:hover": {
                                  bgcolor: "action.hover",
                                  borderColor: "primary.main",
                                },
                                minHeight: 56,
                              }}
                            >
                              <Typography>
                                {editData.kundenID
                                  ? `${editData.kundenID.konto} - ${editData.kundenID.bezeichnung}`
                                  : "Kunde auswählen"}
                              </Typography>
                              <SearchIcon color="action" />
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                      <Divider sx={{ my: 3 }} />
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>MaxLohnFund</FormLabel>
                        <Grid container spacing={2}>
                          <Grid item xs={8}>
                            <TextField
                              label="Wert"
                              type="number"
                              InputProps={{
                                inputProps: {
                                  min: 0,
                                  step:
                                    editData.maxlohnfundUnit === "hours"
                                      ? 0.5
                                      : 1,
                                },
                              }}
                              value={editData.MaxLohnaufwand || ""}
                              onChange={(e) =>
                                handleChange(
                                  "MaxLohnaufwand",
                                  parseFloat(e.target.value) || 0,
                                )
                              }
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl fullWidth>
                              <InputLabel>Einheit</InputLabel>
                              <Select
                                value={editData.maxlohnfundUnit || "hours"}
                                onChange={(e) =>
                                  handleChange(
                                    "maxlohnfundUnit",
                                    e.target.value,
                                  )
                                }
                                label="Einheit"
                              >
                                <MenuItem value="hours">Stunden</MenuItem>
                                <MenuItem value="minutes">Minuten</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </FormControl>

                      <TextField
                        label="Stückkosten"
                        type="number"
                        InputProps={{
                          inputProps: { min: 0, step: 0.01 },
                          startAdornment: (
                            <InputAdornment position="start">€</InputAdornment>
                          ),
                        }}
                        value={editData.MengeCost || ""}
                        onChange={(e) =>
                          handleChange(
                            "MengeCost",
                            parseFloat(e.target.value) || 0,
                          )
                        }
                        fullWidth
                        sx={{ mb: 2 }}
                      />

                      {/* Calculated field (read-only) */}
                      <TextField
                        label="Geschätzter Preis"
                        type="text"
                        value={
                          editData.MaxLohnaufwand && editData.MengeCost
                            ? `€${(
                                calculateHours(
                                  editData.MaxLohnaufwand,
                                  editData.maxlohnfundUnit,
                                ) * parseFloat(editData.MengeCost)
                              ).toFixed(2)}`
                            : "€0.00"
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        sx={{ mb: 2 }}
                      />
                      {/* Additional Select Fields */}
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Versandart</InputLabel>
                        <Select
                          value={editData.shippingMethod || ""}
                          onChange={(e) =>
                            handleChange("shippingMethod", e.target.value)
                          }
                          label="Versandart"
                        >
                          <MenuItem value="selbstabholung">
                            Selbstabholung
                          </MenuItem>
                          <MenuItem value="exwabwerk">EXW - ab Werk</MenuItem>
                          <MenuItem value="freihaus">Frei Haus</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Verpackungsart</InputLabel>
                        <Select
                          value={editData.packagingType || ""}
                          onChange={(e) =>
                            handleChange("packagingType", e.target.value)
                          }
                          label="Verpackungsart"
                        >
                          <MenuItem value="ohne">Ohne</MenuItem>
                          <MenuItem value="einwegpalette">
                            Einwegpalette
                          </MenuItem>
                          <MenuItem value="europalette">Europalette</MenuItem>
                          <MenuItem value="rahmen">
                            Europalette mit Rahmen
                          </MenuItem>
                          <MenuItem value="DHL-kleines">
                            DHL Versand - kleines Paket
                          </MenuItem>
                          <MenuItem value="DHL-großes">
                            DHL Versand - großes Paket
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Fremdleistung</InputLabel>
                        <Select
                          value=""
                          onChange={(e) => {
                            if (
                              e.target.value &&
                              !editData.externalService.includes(e.target.value)
                            ) {
                              const currentServices = normalizeExternalService(
                                editData.externalService || [],
                              );
                              handleChange("externalService", [
                                ...currentServices,
                                e.target.value,
                              ]);
                            }
                          }}
                          label="Fremdleistung hinzufügen"
                        >
                          <MenuItem value="ohne">Ohne</MenuItem>
                          <MenuItem value="normalisieren">
                            Normalisieren
                          </MenuItem>
                          <MenuItem value="harten">Härten</MenuItem>
                          <MenuItem value="gasnitrieren">Gasnitrieren</MenuItem>
                          <MenuItem value="verzahnen">Verzahnen</MenuItem>
                          <MenuItem value="teiflochbohren">
                            Teiflochbohren
                          </MenuItem>
                          <MenuItem value="fremdleistungen">
                            Fremdleistungen
                          </MenuItem>
                        </Select>
                      </FormControl>

                      {/* Display selected external services */}
                      {editData.externalService &&
                        normalizeExternalService(editData.externalService)
                          .length > 0 && (
                          <Box
                            sx={{
                              mb: 2,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                            }}
                          >
                            {normalizeExternalService(
                              editData.externalService,
                            ).map((service, index) => (
                              <Chip
                                key={index}
                                label={service}
                                onDelete={() => {
                                  const currentServices =
                                    normalizeExternalService(
                                      editData.externalService,
                                    );
                                  const updatedServices =
                                    currentServices.filter(
                                      (_, i) => i !== index,
                                    );
                                  handleChange(
                                    "externalService",
                                    updatedServices,
                                  );
                                }}
                                color="secondary"
                                variant="outlined"
                                size="small"
                              />
                            ))}
                          </Box>
                        )}

                      {/* Quality Note Section */}
                      <Box
                        sx={{
                          mb: 3,
                          p: 3,
                          mb: 3,
                          p: 3,
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 2,
                          bgcolor: "background.paper",
                        }}
                      >
                        <Typography
                          variant="h6"
                          gutterBottom
                          sx={{ color: "#1976d2", fontWeight: 600 }}
                        >
                          Qualitätsprüfung
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ mb: 3, color: "#666" }}
                        >
                          Maße/Entgraten/Auszug usw. sind am gefertigten Objekt
                          geprüft
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              type="date"
                              label="Datum"
                              InputLabelProps={{ shrink: true }}
                              value={editData.qualityNote?.datum || ""}
                              onChange={(e) =>
                                handleChange("qualityNote", {
                                  ...(editData.qualityNote || {}),
                                  datum: e.target.value,
                                })
                              }
                              fullWidth
                              variant="outlined"
                              sx={{ borderRadius: 2 }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              label="Anzahl der Werkstücke"
                              type="number"
                              InputProps={{ inputProps: { min: 1 } }}
                              value={editData.qualityNote?.werkstucke || ""}
                              onChange={(e) =>
                                handleChange("qualityNote", {
                                  ...(editData.qualityNote || {}),
                                  werkstucke: e.target.value,
                                })
                              }
                              fullWidth
                              variant="outlined"
                              sx={{ borderRadius: 2 }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Box sx={{ mb: 1 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600 }}
                              >
                                Unterschrift des Prüfers
                              </Typography>
                            </Box>
                            {editData.qualityNote?.untershift ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,

                                  p: 2,
                                  bgcolor: "background.paper",
                                  borderRadius: 2,
                                  border: "1px solid",
                                  borderColor: "divider",
                                }}
                              >
                                <img
                                  src={editData.qualityNote.untershift}
                                  alt="Signature"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "80px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                  }}
                                />
                                <Box sx={{ flex: 1 }}>
                                  <Typography
                                    variant="body2"
                                    color="success.main"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    ✓ Unterschrift vorhanden
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Signiert am:{" "}
                                    {editData.qualityNote?.datum
                                      ? new Date(
                                          editData.qualityNote.datum,
                                        ).toLocaleDateString("de-DE")
                                      : "Unbekannt"}
                                  </Typography>
                                </Box>
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  p: 3,
                                  bgcolor: "background.paper",
                                  borderRadius: 2,
                                  border: "2px dashed",
                                  borderColor: "divider",
                                  textAlign: "center",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Keine Unterschrift vorhanden
                                </Typography>
                              </Box>
                            )}
                          </Grid>
                        </Grid>

                        {/* Quality Status Indicator */}
                        <Box
                          sx={{
                            mt: 2,

                            p: 2,
                            bgcolor: "background.paper",
                            borderRadius: 2,
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            gutterBottom
                          >
                            Qualitätsprüfung Status
                          </Typography>
                          {editData.qualityNote?.datum &&
                          editData.qualityNote?.werkstucke &&
                          editData.qualityNote?.untershift ? (
                            <Typography
                              variant="body1"
                              sx={{ color: "success.main", fontWeight: 600 }}
                            >
                              ✓ Vollständig geprüft
                            </Typography>
                          ) : (
                            <Typography
                              variant="body1"
                              sx={{ color: "warning.main", fontWeight: 600 }}
                            >
                              ⚠ Unvollständig
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Status</FormLabel>
                        <RadioGroup
                          row
                          value={editData.status || ""}
                          onChange={(e) =>
                            handleChange("status", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="ausstehend"
                            control={<Radio />}
                            label="Ausstehend"
                          />
                          <FormControlLabel
                            value="fertig"
                            control={<Radio />}
                            label="Fertig"
                          />
                          <FormControlLabel
                            value="anghalten"
                            control={<Radio />}
                            label="Angehalten"
                          />
                        </RadioGroup>
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Meßwerkzeuge-Status</FormLabel>
                        <RadioGroup
                          row
                          value={editData.MeßwerkzeugeStatus || ""}
                          onChange={(e) =>
                            handleChange("MeßwerkzeugeStatus", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="Meßwerkzeuge im Hause vorhanden"
                            control={<Radio />}
                            label={
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box
                                  component="span"
                                  sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    backgroundColor: "#4caf50",
                                  }}
                                />
                                Meßwerkzeuge im Hause vorhanden
                              </Box>
                            }
                          />
                          <FormControlLabel
                            value="Meßwerkzeuge müssen besorgt werden"
                            control={<Radio />}
                            label={
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box
                                  component="span"
                                  sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    backgroundColor: "#f44336",
                                  }}
                                />
                                Meßwerkzeuge müssen besorgt werden
                              </Box>
                            }
                          />
                          <FormControlLabel
                            value="Messwerkzeuge eingegangen"
                            control={<Radio />}
                            label={
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box
                                  component="span"
                                  sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    backgroundColor: "#ffeb3b",
                                  }}
                                />
                                Messwerkzeuge eingegangen
                              </Box>
                            }
                          />
                        </RadioGroup>
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Materialstatus</FormLabel>
                        <RadioGroup
                          row
                          value={editData.MaterialStatus || ""}
                          onChange={(e) =>
                            handleChange("MaterialStatus", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="Materialeingang erfolgt"
                            control={<Radio />}
                            label="Materialeingang erfolgt"
                          />
                          <FormControlLabel
                            value="Material bestellt"
                            control={<Radio />}
                            label="Material bestellt"
                          />
                          <FormControlLabel
                            value="Materialteillieferung erfolgt"
                            control={<Radio />}
                            label="Materialteillieferung erfolgt"
                          />
                          <FormControlLabel
                            value="Material angefragt"
                            control={<Radio />}
                            label="Material angefragt"
                          />
                        </RadioGroup>
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Werkszeugnisse-Status</FormLabel>
                        <RadioGroup
                          row
                          value={editData.WerkszeugnisseStatus || ""}
                          onChange={(e) =>
                            handleChange("WerkszeugnisseStatus", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="Werkszeugnis eingegangen"
                            control={<Radio />}
                            label="Werkszeugnis eingegangen"
                          />
                          <FormControlLabel
                            value="Teil"
                            control={<Radio />}
                            label="Teil"
                          />
                          <FormControlLabel
                            value="Nicht eingegangen"
                            control={<Radio />}
                            label="Nicht eingegangen"
                          />
                        </RadioGroup>
                      </FormControl>

                      <FormControlLabel
                        sx={{ mb: 2 }}
                        control={
                          <Checkbox
                            checked={!!editData.werkszeugnisRequired}
                            onChange={(e) =>
                              handleChange(
                                "werkszeugnisRequired",
                                e.target.checked,
                              )
                            }
                          />
                        }
                        label="Werkszeugnis erforderlich"
                      />

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Transportstatus</FormLabel>
                        <RadioGroup
                          row
                          value={editData.TransportStatus || ""}
                          onChange={(e) =>
                            handleChange("TransportStatus", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="Organisiert"
                            control={<Radio />}
                            label="Organisiert"
                          />
                          <FormControlLabel
                            value="Nicht organisiert"
                            control={<Radio />}
                            label="Nicht organisiert"
                          />
                        </RadioGroup>
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormLabel>Musterlieferung-Status</FormLabel>
                        <RadioGroup
                          row
                          value={editData.MusterlieferungStatus || ""}
                          onChange={(e) =>
                            handleChange(
                              "MusterlieferungStatus",
                              e.target.value,
                            )
                          }
                        >
                          <FormControlLabel
                            value="Eingang erfolgt"
                            control={<Radio />}
                            label="Eingang erfolgt"
                          />
                          <FormControlLabel
                            value="Kein Eingang"
                            control={<Radio />}
                            label="Kein Eingang"
                          />
                        </RadioGroup>
                      </FormControl>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 4,
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={() =>
                            navigateToNewReklamation(selectedProject.ANR)
                          }
                          startIcon={<AddIcon />}
                          sx={{
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                            backgroundColor: "#28a745",
                            "&:hover": { backgroundColor: "#218838" },
                          }}
                        >
                          Reklamation
                        </Button>

                        {/* Right: Abbrechen & Speichern */}
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Button
                            variant="outlined"
                            onClick={handleBackToTable}
                            startIcon={<ArrowBackIcon />}
                            sx={{
                              borderRadius: 2,
                              px: 3,
                              py: 1,
                              borderColor: "#d1d5db",
                              color: "#4b5563",
                              "&:hover": {
                                borderColor: "#9ca3af",
                                backgroundColor: "#f9fafb",
                              },
                            }}
                          >
                            Abbrechen
                          </Button>
                          <Button
                            variant="contained"
                            onClick={handleSave}
                            startIcon={<SaveIcon />}
                            sx={{
                              borderRadius: 2,
                              px: 3,
                              py: 1,
                              backgroundColor: "#4361ee",
                              "&:hover": {
                                backgroundColor: "#3a56d4",
                              },
                            }}
                          >
                            Speichern
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{ mt: 4 }}>
                        <AnrComments
                          comments={editData.comments}
                          onAddComment={handleAddComment}
                          onEditComment={handleEditComment}
                          onDeleteComment={handleDeleteComment}
                          isDarkMode={false}
                        />
                      </Box>
                    </Paper>
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 100 }}>
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                      <AnrLogs projectId={selectedProject._id} />
                    </Paper>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 2, mb: 6 }}>
                  <Button variant="contained" onClick={handleSave}>
                    Speichern
                  </Button>
                  <Button variant="outlined" onClick={handleBackToTable}>
                    Zurück
                  </Button>
                </Box>
              </Box>
            ) : (
              <Typography>Kein Projekt ausgewählt.</Typography>
            )}
          </Box>
        </div>
      </Box>

      {/* Print Options Dialog */}
      <Dialog
        open={isPrintDialogOpen}
        onClose={() => setIsPrintDialogOpen(false)}
      >
        <DialogTitle>Druckoption auswählen</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Bitte wählen Sie, welche Druckmethode Sie verwenden möchten:
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (selectedProjectForPrint) {
                printBarcodeFunc(selectedProjectForPrint.ANR);
              }
              setIsPrintDialogOpen(false);
            }}
          >
            Barcode drucken
          </Button>
          <Button onClick={handleCustomPrint}>Benutzerdefinierter Druck</Button>
        </DialogActions>
      </Dialog>

      {/* QR Dialog */}
      <Dialog open={qrOpen} onClose={handleCloseQR}>
        <DialogTitle>Dokumente hochladen per QR</DialogTitle>
        <DialogContent>
          {selectedANRForQR && (
            <Box sx={{ textAlign: "center", p: 2 }}>
              <QRCodeCanvas
                value={`https://cnc-heidenau.de/UploadAnrDocumentQR?id=${selectedANRForQR}`}
                size={256}
                includeMargin
              />
              <Typography variant="body2" sx={{ mt: 2 }}>
                QR-Code scannen, um Dokumente für ANR {selectedANRForQR}{" "}
                hochzuladen.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseQR} color="primary">
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add the KundenSelectionDialog component */}
      <KundenSelectionDialog
        open={isKundenDialogOpen}
        onClose={handleCloseKundenDialog}
        onSelectKunde={handleSelectKunde}
        selectedKunde={editData?.kundenID}
      />

      {/* Material Status Dialog */}
      <Dialog open={isMaterialStatusOpen} onClose={handleMaterialStatusClose}>
        <DialogTitle>Meßwerkzeuge-Status aktualisieren</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend">Meßwerkzeuge Status</FormLabel>
            <RadioGroup
              value={materialStatusData?.MeßwerkzeugeStatus || ""}
              onChange={(e) =>
                setMaterialStatusData({
                  ...materialStatusData,
                  MeßwerkzeugeStatus: e.target.value,
                })
              }
            >
              <FormControlLabel
                value="Meßwerkzeuge im Hause vorhanden"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#4caf50",
                      }}
                    />
                    Meßwerkzeuge im Hause vorhanden
                  </Box>
                }
              />
              <FormControlLabel
                value="Meßwerkzeuge müssen besorgt werden"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#f44336",
                      }}
                    />
                    Meßwerkzeuge müssen besorgt werden
                  </Box>
                }
              />
              <FormControlLabel
                value="Messwerkzeuge eingegangen"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#ffeb3b",
                      }}
                    />
                    Messwerkzeuge eingegangen
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMaterialStatusClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleMaterialStatusSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      {/* New Material Status Dialog */}
      <Dialog
        open={isNewMaterialStatusOpen}
        onClose={handleNewMaterialStatusClose}
      >
        <DialogTitle>Materialstatus aktualisieren</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend">Materialstatus</FormLabel>
            <RadioGroup
              value={newMaterialStatusData?.MaterialStatus || ""}
              onChange={(e) =>
                setNewMaterialStatusData({
                  ...newMaterialStatusData,
                  MaterialStatus: e.target.value,
                })
              }
            >
              <FormControlLabel
                value="Materialeingang erfolgt"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#4caf50",
                      }}
                    />
                    Materialeingang erfolgt
                  </Box>
                }
              />
              <FormControlLabel
                value="Material bestellt"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "orange",
                      }}
                    />
                    Material bestellt
                  </Box>
                }
              />
              <FormControlLabel
                value="Materialteillieferung erfolgt"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#ffeb3b",
                      }}
                    />
                    Materialteillieferung erfolgt
                  </Box>
                }
              />
              <FormControlLabel
                value="Material angefragt"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "gray",
                      }}
                    />
                    Material angefragt
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewMaterialStatusClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleNewMaterialStatusSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      {/* Werkszeugnisse Dialog */}
      <Dialog
        open={isWerkszeugnisseStatusOpen}
        onClose={handleWerkszeugnisseStatusClose}
      >
        <DialogTitle>Werkszeugnisse-Status aktualisieren</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend">Werkszeugnisse Status</FormLabel>
            <RadioGroup
              value={werkszeugnisseStatusData?.WerkszeugnisseStatus || ""}
              onChange={(e) =>
                setWerkszeugnisseStatusData({
                  ...werkszeugnisseStatusData,
                  WerkszeugnisseStatus: e.target.value,
                })
              }
            >
              <FormControlLabel
                value="Werkszeugnis eingegangen"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#4caf50",
                      }}
                    />
                    Werkszeugnis eingegangen
                  </Box>
                }
              />
              <FormControlLabel
                value="Teil"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#ffeb3b",
                      }}
                    />
                    Teil
                  </Box>
                }
              />
              <FormControlLabel
                value="Nicht eingegangen"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#f44336",
                      }}
                    />
                    Nicht eingegangen
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={werkszeugnisRequired}
                onChange={(e) => setWerkszeugnisRequired(e.target.checked)}
              />
            }
            label="Werkszeugnis erforderlich"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleWerkszeugnisseStatusClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleWerkszeugnisseStatusSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      {/* Transport Dialog */}
      <Dialog open={isTransportStatusOpen} onClose={handleTransportStatusClose}>
        <DialogTitle>Transportstatus aktualisieren</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend">Transportstatus</FormLabel>
            <RadioGroup
              value={transportStatusData?.TransportStatus || ""}
              onChange={(e) =>
                setTransportStatusData({
                  ...transportStatusData,
                  TransportStatus: e.target.value,
                })
              }
            >
              <FormControlLabel
                value="Organisiert"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#4caf50",
                      }}
                    />
                    Organisiert
                  </Box>
                }
              />
              <FormControlLabel
                value="Nicht organisiert"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#f44336",
                      }}
                    />
                    Nicht organisiert
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTransportStatusClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleTransportStatusSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      {/* Musterlieferung Dialog */}
      <Dialog
        open={isMusterlieferungStatusOpen}
        onClose={handleMusterlieferungStatusClose}
      >
        <DialogTitle>Musterlieferung-Status aktualisieren</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend">Musterlieferung Status</FormLabel>
            <RadioGroup
              value={musterlieferungStatusData?.MusterlieferungStatus || ""}
              onChange={(e) =>
                setMusterlieferungStatusData({
                  ...musterlieferungStatusData,
                  MusterlieferungStatus: e.target.value,
                })
              }
            >
              <FormControlLabel
                value="Eingang erfolgt"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#4caf50",
                      }}
                    />
                    Eingang erfolgt
                  </Box>
                }
              />
              <FormControlLabel
                value="Kein Eingang"
                control={<Radio />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        marginRight: 1,
                        backgroundColor: "#f44336",
                      }}
                    />
                    Kein Eingang
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMusterlieferungStatusClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleMusterlieferungStatusSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      {/* Status Dialog */}
      <Dialog open={isStatusOpen} onClose={handleStatusClose}>
        <DialogTitle>Status aktualisieren</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">Status auswählen</FormLabel>
            <RadioGroup
              value={statusData?.status || ""}
              onChange={(e) =>
                setStatusData({ ...statusData, status: e.target.value })
              }
            >
              <FormControlLabel
                value="ausstehend"
                control={<Radio />}
                label="Ausstehend"
              />
              <FormControlLabel
                value="fertig"
                control={<Radio />}
                label="Fertig"
              />
              <FormControlLabel
                value="anghalten"
                control={<Radio />}
                label="Angehalten"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStatusClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleStatusSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      {/* Hidden Barcode Container for each row */}
      {filteredData.map((project) => (
        <div
          key={project._id}
          style={{ display: "none" }}
          id={`barcode-${project.ANR}`}
        >
          <Barcode value={project.ANR} />
          {project.kundenID && (
            <div>
              {project.kundenID.bezeichnung} - {project.kundenID.konto}
            </div>
          )}
        </div>
      ))}

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Missing Sequence Dialog */}
      <Dialog
        open={missingSequenceDialogOpen}
        onClose={() => setMissingSequenceDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Fehlende Sequenz</DialogTitle>
        <DialogContent>
          {missingSequence.length === 0 ? (
            <Typography>
              Keine einfache Lücke oder große Lücke in der Sequenz.
            </Typography>
          ) : (
            <Typography>
              Folgende Sequenznummer(n) fehlen: {missingSequence.join(", ")}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMissingSequenceDialogOpen(false)}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Parent ANR Dialog */}
      <Dialog open={isParentOpen} onClose={handleParentClose}>
        <DialogTitle>Eltern-ANR festlegen</DialogTitle>
        <DialogContent>
          {parentData && (
            <TextField
              label="Eltern-ANR"
              value={parentData.parentANR || ""}
              onChange={(e) =>
                setParentData({ ...parentData, parentANR: e.target.value })
              }
              fullWidth
              margin="normal"
            />
          )}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
              }
              label="Mit Unterstrich bilden (optional)?"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleParentClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleParentSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isMaxLohnFundDialogOpen} onClose={handleMaxLohnFundClose}>
        <DialogTitle>MaxLohnFund aktualisieren</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {maxLohnFundData && (
            <>
              <Typography variant="subtitle1" gutterBottom>
                ANR: {maxLohnFundData.ANR}
              </Typography>

              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={8}>
                  <TextField
                    label="Wert"
                    type="number"
                    InputProps={{
                      inputProps: {
                        min: 0,
                        step:
                          maxLohnFundData.maxlohnfundUnit === "hours" ? 0.5 : 1,
                      },
                    }}
                    value={maxLohnFundData.MaxLohnaufwand}
                    onChange={(e) =>
                      setMaxLohnFundData({
                        ...maxLohnFundData,
                        MaxLohnaufwand: parseFloat(e.target.value) || 0,
                      })
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Einheit</InputLabel>
                    <Select
                      value={maxLohnFundData.maxlohnfundUnit || "hours"}
                      onChange={(e) =>
                        setMaxLohnFundData({
                          ...maxLohnFundData,
                          maxlohnfundUnit: e.target.value,
                        })
                      }
                      label="Einheit"
                    >
                      <MenuItem value="hours">Stunden</MenuItem>
                      <MenuItem value="minutes">Minuten</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <TextField
                label="Stückkosten"
                type="number"
                InputProps={{
                  inputProps: { min: 0, step: 0.01 },
                  startAdornment: (
                    <InputAdornment position="start">€</InputAdornment>
                  ),
                }}
                value={maxLohnFundData.MengeCost}
                onChange={(e) =>
                  setMaxLohnFundData({
                    ...maxLohnFundData,
                    MengeCost: parseFloat(e.target.value) || 0,
                  })
                }
                fullWidth
                sx={{ mt: 2 }}
              />

              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: "background.paper",
                  borderRadius: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  Berechneter Wert:
                </Typography>
                <Typography variant="h6">
                  Geschätzter Preis: €
                  {(
                    calculateHours(
                      maxLohnFundData.MaxLohnaufwand,
                      maxLohnFundData.maxlohnfundUnit,
                    ) * parseFloat(maxLohnFundData.MengeCost)
                  ).toFixed(2)}
                </Typography>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMaxLohnFundClose} color="inherit">
            Abbrechen
          </Button>
          <Button onClick={handleMaxLohnFundSave} color="primary">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StockAuftrageView;
